import { ComponentProps, FC } from 'react';

import { ProductCardLoading } from '../ProductCard/ProductCardLoading';
import { ProductGrid } from '../ProductGrid/ProductGrid';

type Props = Pick<ComponentProps<typeof ProductGrid>, 'variant'> & {
  tilesNumber?: number;
};

export const ResultsLoading: FC<Props> = ({ tilesNumber = 18, variant }) => (
  <div className="c-queries--inline">
    <ProductGrid variant={variant}>
      {[...Array(tilesNumber).keys()].map((item) => (
        <ProductCardLoading key={item} variant="plp" />
      ))}
    </ProductGrid>
  </div>
);
